import React from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { Grid } from '@material-ui/core';

import Field from 'core/components/form/form.v2';
import { SubRiskCollapsibleSection } from './sub-risk-collapsible-section';
import useStyles from './sub-risk.styles';

const DwellingUnderConstructionForm = ({ fieldName, disabled }) => {
  const classes = useStyles();

  return (
    <SubRiskCollapsibleSection
      type="secondary"
      content={<div className={classes.headerText}>Dwelling under construction (theft)</div>}
      initialOpen={false}
    >
      <Grid container spacing={2}>
        <Field
          xs={6}
          type="numeric"
          id={`${fieldName}.resUnderConstructionLimit`}
          name={`${fieldName}.resUnderConstructionLimit`}
          mode="dark"
          label="Coverage limit"
          format={{ thousandSeparator: true, prefix: '$' }}
          disabled={disabled}
        />
        <Field
          xs={6}
          type="date"
          id={`${fieldName}.resUnderConstructionEffectiveDate`}
          name={`${fieldName}.resUnderConstructionEffectiveDate`}
          mode="dark"
          label="Effective date"
          disabled={disabled}
          defaultToEmpty
        />
      </Grid>
    </SubRiskCollapsibleSection>
  );
};

DwellingUnderConstructionForm.propTypes = {
  fieldName: PropTypes.string.isRequired,
  disabled: PropTypes.bool
};

DwellingUnderConstructionForm.defaultProps = {
  disabled: false
};

export default observer(DwellingUnderConstructionForm);
